<template>
  <div class="container mt-5 mb-md-4 py-5">
    <breadcrumb class="mb-3 mb-md-4 pt-md-3" :crumbs="crumbs"></breadcrumb>

    <!-- Page content -->
    <div class="row justify-content-center pb-sm-2 pt-3">
      <div class="col-lg-6">
        <h1 class="h2 text-center pb-4 mb-3">Setup Your Account</h1>

        <div class="bg-light rounded-3 py-4 px-md-4">

          <form action="post" @submit.prevent="setupAccount">
            <!-- Email -->
            <div class="mb-4">
              <label class="form-label" for="email">Email <span class="text-danger">*</span></label>
              <input v-model="form.email" class="form-control form-control-lg" type="email" id="email"
                     :disabled="true"
                     placeholder="Enter your email address" required>
            </div>
            <!-- / Email -->

            <!-- New Password -->
            <div class="mb-4">
              <label class="form-label" for="new_password">New Password <span class="text-danger">*</span></label>
              <input v-model="form.new_password" class="form-control form-control-lg" type="password" id="new_password"
                     placeholder="Enter your new password" required>
              <small class="form-text text-muted">Password must be at least 8 characters long.</small>
            </div>
            <!-- / New Password -->

            <!-- Confirm Password -->
            <div class="mb-4">
              <label class="form-label" for="confirm_password">Confirm Password <span class="text-danger">*</span></label>
              <input v-model="form.confirm_password" class="form-control form-control-lg" type="password" id="confirm_password"
                     placeholder="Confirm your new password" required>
            </div>
            <!-- / Confirm Password -->

            <input type="submit" class="d-none"/>

            <div class="actions-wrapper">
              <div class="left">
                <a :class="{'disabled': isLoading}"
                   @click.prevent="setupAccount" class="btn btn-primary btn-lg rounded-pill ms-sm-auto" href="#">
                  <spinner v-if="isLoading" class="spinner-border-sm me-2"></spinner>
                  <i v-else class="fi-user fs-sm me-2"></i>
                  Setup Account
                </a>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
    <!-- / Page content -->
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Spinner from "../components/Spinner";
import setupAccountApi from "../api/setup-account";
import { useToast } from 'vue-toastification';
import { mapActions } from 'vuex';

const toast = useToast();

export default {
  components: {Breadcrumb, Spinner},
  data() {
    return {
      crumbs: [
        {
          href: '/',
          label: 'Home'
        },
        {
          href: '#',
          label: 'Setup Account',
          active: true
        }
      ],
      form: {
        email: '',
        setup_token: '',
        new_password: '',
        confirm_password: ''
      },
      isLoading: false
    }
  },
  created() {
    // Get email and setup token from query parameters
    const email = this.$route.query.e;
    const setupToken = this.$route.query.st;
    
    // Validate required parameters
    if (!email) {
      toast.error('Email not provided');
      this.$router.push('/login');
      return;
    }
    
    if (!setupToken) {
      toast.error('Setup token not provided');
      this.$router.push('/login');
      return;
    }
    
    // Set form values
    this.form.email = email;
    this.form.setup_token = setupToken;
  },
  methods: {
    ...mapActions('auth', {
      attemptLogin: 'attemptLogin'
    }),

    setupAccount() {
      // Validate passwords match
      if (this.form.new_password !== this.form.confirm_password) {
        toast.error('Passwords do not match');
        return;
      }

      // Validate password length
      if (this.form.new_password.length < 8) {
        toast.error('Password must be at least 8 characters long');
        return;
      }

      this.isLoading = true;

      setupAccountApi.setupAccount({
        email: this.form.email,
        setup_token: this.form.setup_token,
        new_password: this.form.new_password
      }).then(response => {
        this.isLoading = false;
        toast.success('Account setup successfully! Logging you in...');
        
        // Auto login with the new credentials
        this.attemptLogin({
          email: this.form.email,
          password: this.form.new_password,
          to: this.$route.query.to ? this.$route.query.to : '/'
        });
      }).catch(error => {
        this.isLoading = false;
        
        let errorMessage = 'Something went wrong. Please try again.';
        
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        
        toast.error(errorMessage);
      });
    }
  }
}
</script>

<style scoped lang="scss">
.actions-wrapper {
  display: flex;

  .left {
    flex-grow: 1;
  }

  .right {
    flex-shrink: 1;
    display: flex;
    align-items: center;
  }
}
</style> 